
import { User } from "@/js/types/user"
import { defineComponent } from "vue"

export default defineComponent({
    name: "Home",
    computed: {
        user(): User {
            return this.$page.props.auth.user
        },
        userAvatar(): string {
            return this.user.avatar_url ? this.user.avatar_url : "/icons/user.png"
        },
    },
})
